import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GatewayProvider, GatewayDest } from 'react-gateway';
import Modal from 'react-modal2';
import { Analytics } from './applicationServices/analytics';
import GlobalErrorAndRedirectionListener from './components/GlobalErrorAndRedirectionListener';
import InstantExperiences from './instantExperiences/InstantExperiences';
import FbPixel from './applicationServices/analytics/containers/FbPixel';
import { setApplePay } from './actions';
import { AcceptCookies, getAcceptCookie } from './acceptCookies';
import '../scss/app.scss';
import analytics from '../app/applicationServices/analytics/BookingAnalytics';

const APP_ID = 'app';

class App extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    setApplePay: PropTypes.func.isRequired,
    acceptCookie: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);

    // Pass app div to modal for accessibility features
    Modal.getApplicationElement = () => document.getElementById(`${APP_ID}`);
    this.onPageLoad = () => analytics.pageLoaded();
  }

  componentDidMount() {
    this.props.setApplePay();
    window.addEventListener('load', this.onPageLoad);
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.onPageLoad);
  }

  render() {
    return (
      <GatewayProvider>
        <div>
          <div id={APP_ID} className="u-pb+ large-and-up-pb0">
            {this.props.children}
            <GlobalErrorAndRedirectionListener />
          </div>
          <GatewayDest name="modal" />
          { this.props.acceptCookie && <Analytics /> }
          <InstantExperiences />
          <FbPixel />
          <AcceptCookies />
        </div>
      </GatewayProvider>
    );
  }
}

function mapStateToProps(state) {
  let user;
  if (state.newCustomer) {
    user = {
      user_id: state.newCustomer.id,
      email: state.newCustomer.email,
      name: `${state.newCustomer.firstName} ${state.newCustomer.lastName}`,
    };
  }

  return {
    user,
    customer: state.reservation.newCustomer,
    acceptCookie: getAcceptCookie(state),
  };
}

const mapDispatchToProps = {
  setApplePay,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/app/index.jsx